import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useReveal from "@/hooks/useReveal";
import { setPageSEO } from "@/lib/seo";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import SubpageHero from "@/components/landing/SubpageHero";
import Process from "@/components/landing/Process";
import BeforeAfter from "@/components/landing/BeforeAfter";
import WhatThisMeans from "@/components/landing/WhatThisMeans";
import FinalCTA from "@/components/landing/FinalCTA";

export default function Implementacion() {
  useReveal();

  useEffect(() => {
    setPageSEO({
      title: "Cómo Implementar EOS en tu Empresa | Proceso Paso a Paso | Carlos Garcín Chile",
      description: "Cómo implementar EOS en tu empresa: desde la reunión gratuita hasta el Quarterly Pulsing. Acompañamiento paso a paso con Carlos Garcín en Chile.",
      path: "/implementacion",
      keywords: "cómo implementar EOS, proceso implementación EOS, capacitación EOS equipo directivo, Quarterly Pulsing, Focus Day EOS, EOS paso a paso",
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main>
        <SubpageHero
          eyebrow="El proceso EOS"
          title="Cómo implementar EOS en tu empresa"
          subtitle="Un proceso probado, estructurado y acompañado. Desde la primera llamada hasta el ritmo trimestral de ejecución — sin improvisar, sin perder el hilo."
          withCta
        />
        <Process />

        {/* Aclaración búsqueda "capacitación EOS" — contenido único, primera persona */}
        <section data-testid="capacitacion-eos-note" className="py-14 sm:py-16 bg-slate-50 border-y border-slate-100">
          <div className="container-eos max-w-3xl">
            <div className="reveal">
              <span className="eyebrow">¿Buscas capacitación EOS?</span>
              <h2 className="mt-3 font-display font-extrabold text-2xl sm:text-3xl text-navy-800 leading-tight">
                Entiendo la pregunta, pero hago algo más profundo que un curso.
              </h2>
              <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
                Muchos empresarios buscan una "capacitación EOS" puntual para su equipo. Yo no dicto cursos abiertos ni talleres aislados: como Professional EOS Implementer, instalo la metodología completa dentro de tu empresa —con sesiones de Focus Day, Vision Building y un acompañamiento trimestral (Quarterly Pulsing)— para que tu equipo de liderazgo aprenda EOS haciéndolo, no solo escuchándolo.
              </p>
              <p className="mt-4">
                <Link to="/implementador-eos" data-testid="implementacion-implementador-link" className="text-[#F26522] hover:underline font-semibold">
                  Así trabajo personalmente en la implementación de EOS →
                </Link>
              </p>
            </div>
          </div>
        </section>

        <BeforeAfter />
        <WhatThisMeans />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-right" />
    </>
  );
}
